<header
  class="flex justify-between items-center px-6 md:px-20 py-[24px] border-b border-gray-200"
>
  <div
    class="flex w-full md:w-auto gap-4 flex-col md:flex-row md:items-center justify-start"
  >
    <div class="flex w-full items-start justify-between">
      <a routerLink="/">
        <img
          [src]="assetUrl + 'icons/gloget_logo-trans.png'"
          class="w-[96px] min-w-[96px]"
          alt="Gloget logo"
        />
      </a>

      <button
        type="button"
        (click)="showMenu = !showMenu"
        class="flex flex-end py-1 p-0 md:hidden"
        aria-label="Toggle navigation"
        [attr.aria-expanded]="showMenu"
      >
        <img [src]="assetUrl + 'icons/menu.svg'" alt="" />
      </button>
    </div>

    @if (showMenu) {
      <nav class="pl-6">
        <ul class="flex flex-col md:flex-row gap-8">
          <li>
            <a
              [routerLink]="['/customer/search']"
              [queryParams]="{ category: 'hair' }"
              class="whitespace-nowrap scale-text-hover text-lg"
              data-text="Hair"
            >
              Hair
            </a>
          </li>

          <li>
            <a
              [routerLink]="['/customer/search']"
              [queryParams]="{ category: 'nails' }"
              class="whitespace-nowrap scale-text-hover text-lg"
              data-text="Nails"
            >
              Nails
            </a>
          </li>

          <li>
            <a
              [routerLink]="['/customer/search']"
              [queryParams]="{ category: 'face' }"
              class="whitespace-nowrap scale-text-hover text-lg"
              data-text="Face"
            >
              Face
            </a>
          </li>

          <li>
            <a
              [routerLink]="['/customer/search']"
              [queryParams]="{ category: 'body' }"
              class="whitespace-nowrap scale-text-hover text-lg"
              data-text="Body"
            >
              Body
            </a>
          </li>

          <li>
            <a
              routerLink="/faq"
              class="whitespace-nowrap scale-text-hover text-lg"
              data-text="FAQ"
            >
              FAQ
            </a>
          </li>
        </ul>
      </nav>
    }
  </div>

  <div class="gap-4 hidden md:flex">
    <!-- =====================================================
         LOCATION
    ====================================================== -->

    <div class="h-[48px] flex-shrink-0">
      @if (detectingLocation) {
        <div class="w-full h-full flex items-center">
          <span class="text-sm text-gray-500"> Locating... </span>
        </div>
      } @else if (detectedCityName) {
        <div
          class="detected-location"
          [title]="'Current location: ' + detectedCityName"
        >
          <div class="detected-location__icon">
            <img [src]="assetUrl + 'icons/marker-lg.svg'" alt="" />
          </div>

          <div class="detected-location__content">
            <span class="detected-location__label"> Near you </span>

            <span class="detected-location__city">
              {{ detectedCityName }}
            </span>
          </div>

          <span class="detected-location__dot"></span>
        </div>
      } @else {
        <glo-control
          class="w-[140px]"
          icon="marker-lg"
          [options]="cities"
          type="select"
          [(value)]="selectedCityId"
          (valueChange)="onFallbackCityChange($event)"
        ></glo-control>
      }
    </div>

    <!-- =====================================================
         CUSTOMER / BUSINESS SWITCH
    ====================================================== -->

    <div class="w-[140px] h-[48px] flex items-center justify-center">
      @if (isBusiness) {
        <button
          type="button"
          routerLink="/"
          class="px-6 py-2 shadow rounded-3xl text-gray-700 bg-white btn-hover"
        >
          For Customer
        </button>
      } @else {
        <button
          type="button"
          routerLink="/business"
          class="px-6 py-2 shadow rounded-3xl text-gray-700 bg-white btn-hover"
        >
          For Business
        </button>
      }
    </div>

    <!-- =====================================================
         PROFILE / LOGIN
    ====================================================== -->

    @if (isLoggedIn) {
      <div class="logged-user relative">
        <button
          type="button"
          aria-label="Toggle profile menu"
          aria-haspopup="true"
          [attr.aria-expanded]="isProfileDrdnOpen"
          (click)="isProfileDrdnOpen = !isProfileDrdnOpen"
          class="px-5 py-2 truncate w-[165px] shadow rounded-3xl text-gray-700"
        >
          {{ user?.full_name || "My Account" }}
        </button>

        @if (isProfileDrdnOpen) {
          <div
            class="absolute top-12 right-0 profile-drdn z-20 bg-zinc-50 flex flex-col border border-gray-200 rounded-lg text-sm font-semibold min-w-[230px]"
          >
            <!-- PROFILE SUMMARY -->

            <div
              class="flex gap-2 px-3 py-3 items-center border-b border-gray-200"
            >
              <mat-icon style="width: 30px; height: 30px; font-size: 30px">
                account_circle
              </mat-icon>

              <div class="flex flex-col min-w-0">
                <span class="truncate font-semibold">
                  {{ user?.full_name || "My Account" }}
                </span>

                <span class="text-xs text-gray-500">
                  @if (isPlatformAdmin) {
                    Platform Administrator
                  } @else if (isBusinessOwner) {
                    Business Owner
                  } @else if (isStaff) {
                    Staff
                  } @else if (isCustomer) {
                    Customer
                  } @else {
                    My Account
                  }
                </span>
              </div>
            </div>

            <!-- =====================================================
                 PLATFORM ADMIN MENU
            ====================================================== -->

            @if (isPlatformAdmin) {
              <a
                routerLink="/admin/platform/overview"
                (click)="isProfileDrdnOpen = false"
                class="flex items-center px-3 py-3 cursor-pointer hover:bg-gray-100"
              >
                <mat-icon class="mr-2">dashboard</mat-icon>
                <span>Admin Dashboard</span>
              </a>

              <a
                routerLink="/admin/platform/users"
                (click)="isProfileDrdnOpen = false"
                class="flex items-center px-3 py-3 cursor-pointer hover:bg-gray-100"
              >
                <mat-icon class="mr-2">people</mat-icon>
                <span>User Management</span>
              </a>

              <a
                routerLink="/admin/platform/businesses"
                (click)="isProfileDrdnOpen = false"
                class="flex items-center px-3 py-3 cursor-pointer hover:bg-gray-100"
              >
                <mat-icon class="mr-2">store</mat-icon>
                <span>Businesses &amp; Salons</span>
              </a>

              <a
                routerLink="/admin/platform/beta-testers"
                (click)="isProfileDrdnOpen = false"
                class="flex items-center px-3 py-3 cursor-pointer hover:bg-gray-100 border-b border-gray-200"
              >
                <mat-icon class="mr-2">science</mat-icon>
                <span>Beta Testers</span>
              </a>

              <!-- Platform Admin Settings is not yet implemented.
                  Do not redirect administrators to customer settings. -->

              } @else if (isBusinessOwner) {

                <!-- =====================================================
                    BUSINESS OWNER MENU
                ====================================================== -->

                <a
                  routerLink="/admin/business/overview"
                  (click)="isProfileDrdnOpen = false"
                  class="flex items-center px-3 py-3 cursor-pointer hover:bg-gray-100"
                >
                  <mat-icon class="mr-2">dashboard</mat-icon>
                  <span>Business Dashboard</span>
                </a>

                <a
                  routerLink="/admin/business/appointments"
                  (click)="isProfileDrdnOpen = false"
                  class="flex items-center px-3 py-3 cursor-pointer hover:bg-gray-100"
                >
                  <mat-icon class="mr-2">event</mat-icon>
                  <span>Appointments</span>
                </a>

                <a
                  routerLink="/admin/business/account"
                  (click)="isProfileDrdnOpen = false"
                  class="flex items-center px-3 py-3 cursor-pointer hover:bg-gray-100 border-b border-gray-200"
                >
                  <mat-icon class="mr-2">settings</mat-icon>
                  <span>Business Settings</span>
                </a>

              } @else if (isStaff) {

                <!-- =====================================================
                    STAFF MENU
                ====================================================== -->

                <a
                  routerLink="/admin/staff/overview"
                  (click)="isProfileDrdnOpen = false"
                  class="flex items-center px-3 py-3 cursor-pointer hover:bg-gray-100"
                >
                  <mat-icon class="mr-2">dashboard</mat-icon>
                  <span>Staff Dashboard</span>
                </a>

                <a
                  routerLink="/admin/staff/appointments"
                  (click)="isProfileDrdnOpen = false"
                  class="flex items-center px-3 py-3 cursor-pointer hover:bg-gray-100"
                >
                  <mat-icon class="mr-2">event</mat-icon>
                  <span>Appointments</span>
                </a>

              } @else if (isCustomer) {

                <!-- =====================================================
                    CUSTOMER MENU
                ====================================================== -->

              <a
                routerLink="/admin/customer/appointments"
                (click)="isProfileDrdnOpen = false"
                class="flex items-center px-3 py-3 cursor-pointer hover:bg-gray-100"
              >
                <img [src]="assetUrl + 'icons/user.svg'" class="pr-2" alt="" />

                <span>My Appointments</span>
              </a>

              <a
                routerLink="/admin/customer/account"
                (click)="isProfileDrdnOpen = false"
                class="flex items-center px-3 py-3 cursor-pointer hover:bg-gray-100 border-b border-gray-200"
              >
                <img
                  [src]="assetUrl + 'icons/settings.svg'"
                  class="pr-2"
                  alt=""
                />

                <span>Settings</span>
              </a>

              <a
                routerLink="/admin/customer/support"
                (click)="isProfileDrdnOpen = false"
                class="flex items-center px-3 py-3 cursor-pointer hover:bg-gray-100 border-b border-gray-200"
              >
                <img
                  [src]="assetUrl + 'icons/help-circle.svg'"
                  class="pr-2"
                  alt=""
                />

                <span>Support</span>
              </a>
            }

            <!-- =====================================================
                 SHARED SIGN OUT
            ====================================================== -->

            <button
              type="button"
              (click)="signOut()"
              class="flex items-center px-3 py-3 w-full text-left hover:bg-gray-100"
            >
              <mat-icon class="mr-2">logout</mat-icon>
              <span>Sign out</span>
            </button>
          </div>
        }
      </div>
    } @else {
      <button
        type="button"
        [routerLink]="'/login'"
        class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white"
      >
        Login
      </button>
    }
  </div>
</header>
